export const ISAErrorMsg = 'Unable to validate ISA Number, please cross check the given ISA Number';
export default {};
